import { ETotalCollected } from './types';

export const TOTAL_COLLECTED_OPTION = [
  { value: ETotalCollected.dividends, title: 'account.collection.tooltip.dividends' },
  { value: ETotalCollected.cashback, title: 'account.collection.tooltip.cashback' },
  { value: ETotalCollected.referral, title: 'account.collection.tooltip.referral' },
  { value: ETotalCollected.rakeback, title: 'cashback.ranks.rakeback' },
];
